import { useEffect, useRef, useState } from "react";
import { FaBars } from "react-icons/fa";
import { IoCloseOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import logo from "../../Images/SelfSync Logo.png";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef();

  const navItems = [
     { label: "Partner With Us", path: "/partner-with-us" },
    { label: "Contact Us", path: "/contact-us" },
    { label: "Pricing", path: "/pricing" },
    {label:"Demo",path:"/schedule-demo"},
    { label: "Register", external: true, url: "https://portal.selfsync.ai/sign-up" },
  ];

  const handleNavClick = (item) => {
    if (item.external && item.url) {
      window.open(item.url, "_blank");
    } else if (item.path) {
      navigate(item.path);
      setMenuOpen(false);
    } else if (item.id) {
      const el = document.getElementById(item.id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Close menu on outside click (mobile)
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
        {/* Logo */}
        <div
          className="text-2xl font-bold cursor-pointer"
          onClick={() => navigate("/")}
        >
          <img src={logo} alt="SelfSync Logo" className="h-11" />
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-10 text-md font-semibold">
          {navItems.map((item) => (
            <button
              key={item.label}
              onClick={() => handleNavClick(item)}
              className={` ${
                item.label === "Register"
                  ? "custom-button px-4 py-2 rounded-md  shadow-md"
                  : " "
              }`}
            >
              {item.label}
            </button>
          ))}
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-gray-700"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
        >
          {menuOpen ? (
            <IoCloseOutline className="hover:text-purple-700" size={24} />
          ) : (
            <FaBars className="font-thin hover:text-purple-700" size={24} />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div
          ref={menuRef}
          className="md:hidden px-6 pb-6 space-y-6  py-2 bg-white shadow-md"
        >
          {navItems.map((item) => (
            <button
              key={item.label}
              className={`block text-left w-2/4  text-base font-semibold ${
                item.label === "Register"
                  ? "custom-button  text-center text-white  px-4 py-2 rounded-md shadow-md"
                  : ""
              }`}
              onClick={() => handleNavClick(item)}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};

export default Header;
